export const TYPES = {
  CENTERED: 'centered',
  FULL_SCREEN: 'fullScreen',
  RESPONSIVE: 'responsive',
}

export const DEFAULT_STATE = {
  Component: '',
  isOpen: false,
  closable: false,
  type: TYPES.CENTERED,
  maxWidth: 'xs',
}
